import { setAddressFromGooglePlace } from "./reducerHelpers/addressHelpers";
import {
  addProductsState,
  setProductsState,
  setProductQuantity,
  replaceProductsState
} from "./productsState";
import { setOrderPayloadState } from "./orderPayloadState";
import { setOrderResp, addOrderErrorResp } from "./orderRespState";

function reducer(state, action) {
  switch (action.type) {
    case "SET_CHECKOUT_FLOW":
      return { ...state, checkoutFlow: action.payload };
    case "SET_ADDRESS":
      if (action.payload.address_components) {
        return setAddressFromGooglePlace(state, action.payload);
      } else {
        return state;
      }
    case "SET_PRODUCTS":
      return setProductsState(state, action.payload);
    case "ADD_PRODUCTS":
      return addProductsState(state, action.payload);
    case "REPLACE_PRODUCT":
      return replaceProductsState(state, action.payload);
    case "SET_PRODUCT_QUANTITY":
      return setProductQuantity(state, action.payload);
    case "SET_ORDER_PAYLOAD":
      return setOrderPayloadState(state, action.payload);
    case "SET_ORDER_RESP":
      return setOrderResp(state, action.payload);
    case "ADD_ORDER_ERROR_RESP":
      return addOrderErrorResp(state, action.payload);
    case "SET_PHOTO_MOD_DATA":
      return { ...state, moderatedSelfieData: action.payload };
    case "SET_STEP1":
      return { ...state, step1: { ...state.step1, ...action.payload } };
    case "SET_STEP2":
      return { ...state, step2: { ...state.step2, ...action.payload } };
    case "SET_STEP3":
      return { ...state, step3: { ...state.step3, ...action.payload } };
    case "TOGGLE_APP_OVERLAY":
      return { ...state, appOverlayActive: action.payload };
    case "SET_SUBMIT_MESSAGE_PHRASE_KEY":
      return { ...state, submitMessagePhraseKey: action.payload };
    case "SET_ORDER_PHOTO":
      return { ...state, currentOrder: { ...state.currentOrder, photo: action.payload } };
    case "SET_HAS_TAKEN_PHOTO":
      return { ...state, hasTakenPhoto: action.payload };
    case "SET_RCDS_FAILOVER":
      return {
        ...state,
        rcdsFailover: action.payload
      };
    default:
      break;
  }
}

export default reducer;
